import styled from 'styled-components'

import MarkdownRender from 'components/Luxkit/MarkdownRender'

const NotesRender = styled(MarkdownRender)`
  overflow-wrap: break-word;
`

export default NotesRender
